var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCursor(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 13,
    viewBox: "0 0 10 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.29871 0.82504L9.55671 6.81771C9.74991 6.97706 9.88906 7.19229 9.95508 7.43388C10.0211 7.67546 10.0107 7.93155 9.92544 8.16701C9.84014 8.40247 9.68406 8.60577 9.47863 8.74901C9.2732 8.89225 9.02848 8.96841 8.77804 8.96704H6.17137C5.79334 8.96688 5.42041 9.05432 5.08185 9.22251C4.74329 9.39069 4.4483 9.63503 4.22004 9.93637L2.64937 12.0144C2.49857 12.2141 2.28998 12.3627 2.0519 12.4398C1.81381 12.517 1.55775 12.5191 1.31844 12.4458C1.07913 12.3725 0.868157 12.2274 0.714124 12.0301C0.560091 11.8328 0.470456 11.593 0.457374 11.343L4.09933e-05 1.96704C-0.0135784 1.69487 0.0525297 1.42465 0.190257 1.1895C0.327985 0.95436 0.531344 0.764524 0.775394 0.643277C1.01944 0.522031 1.29357 0.474645 1.56416 0.506932C1.83475 0.539219 2.09004 0.649775 2.29871 0.82504Z",
    fill: "#8C8C8C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCursor);
export default __webpack_public_path__ + "static/media/cursor.8cb66e76756b70b7eb8f0b61a135043f.svg";
export { ForwardRef as ReactComponent };